// extracted by mini-css-extract-plugin
export default {"section":"Suot9muYuLJLwL9UTu7x","sectionTitle":"AwRqLV7Oz8HXCqNEYh5y","recommendedHotels":"onrQFMtJ_PR3OyhoWEts"};